import AsyncStorage from '@react-native-async-storage/async-storage'

// types
import { HomeCache } from '../types/globalTypes'

const homeCache = async (): Promise<HomeCache> => {
  const data = await AsyncStorage.getItem('@Profile')

  return JSON.parse(data)
}

const homeMessageResponseTitle = (
  type: 'E' | 'A'
): { message: string; response: string } => {
  return {
    message: type === 'E' ? 'Latest Message' : 'Admin Message',
    response: type === 'E' ? 'Admin Reply' : 'Reply'
  }
}

export { homeCache, homeMessageResponseTitle }
